import React, { Component } from 'react'
import { message, Form, Input, Button, Card, Timeline, Spin } from 'antd'
import { connect } from 'dva'
import moment from 'moment'
import { all, create } from '../../services/restApi'
import { batchArray } from '../../services/batch'
const _ = require('underscore')

const FormItem = Form.Item;
const TextArea = Input.TextArea;

class InvoiceMessage extends Component {

    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    constructor (props) {
        super(props);

        this.state = {
            skip: 0,
            limit: 5,
            total_items: 0,
            messages: []
        };

        // Consulta los mensajes de la factura
        if (this.props.invoiceId) {
            this.props.dispatch({type: 'app/showLoadingTable'})

            all('InvoiceMessage', {
                where: {
                    invoice: {__type: 'Pointer', className: 'Invoice', objectId: this.props.invoiceId}
                },
                include: 'invoice,user',
                skip: this.state.skip,
                limit: this.state.limit,
                order: '-createdAt',
                count: 1
            }).then((resp) => {

                this.setState({
                    skip: this.state.skip + this.state.limit, 
                    total_items: resp.count,
                    messages: resp.results
                });
                this.props.dispatch({type: 'app/hideLoadingTable'})
                this.mark_read();

            }).catch(e => {
                this.props.dispatch({type: 'app/hideLoadingTable'})
                message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
            });
        }
    }


	/**
	* Carga otro bloque de registros
	*/
    loadMore (e) {
        e.preventDefault();
    	if (this.state.skip < this.state.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})

    		all('InvoiceMessage', {
                where: {
                    invoice: {__type: 'Pointer', className: 'Invoice', objectId: this.props.invoiceId}
                },
                include: 'invoice,user',
                skip: this.state.skip,
                limit: this.state.limit,
                order: '-createdAt',
                count: 1
            }).then((resp) => {

                this.setState({
                    skip: this.state.skip + this.state.limit, 
                    total_items: resp.count,
                    messages: this.state.messages.concat(resp.results)
                });
                this.props.dispatch({type: 'app/hideLoadingTable'})

            }).catch(e => {
                this.props.dispatch({type: 'app/hideLoadingTable'})
                message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
            });
    	}
    }


    /**
    * Marca todos los mensajes que no están leídos a Leídos
    */
    mark_read () {
        let dispatch = this.props.dispatch

        all('InvoiceMessage', {
            where: {
                invoice: {__type: 'Pointer', className: 'Invoice', objectId: this.props.invoiceId},
                read: false
            },
            include: 'client,client.hotel',
            limit: 100,
        }).then(resp => {
            // Establecemos que la factura actual ya no tiene mensajes
            dispatch({ type: 'invoice/updateSuccess', payload: {objectId: this.props.invoiceId, hasMessages: false} });

            let requests = [];
            if (resp.results.length > 0) {
                _.map(resp.results, (item, key) => {
                    requests.push({
                        method: 'PUT',
                        path: '/crmhotel/classes/InvoiceMessage/' + item.objectId,
                        body: {
                            read: true,
                        }
                    });

                    if (key === resp.results.length - 1) {
                        batchArray({requests: requests});
                    }
                })
            }
        });
  	}


    /**
    * Envío del formulario
    */
    createMessage (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.read = false;
            data.user = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.invoice = {__type: 'Pointer', className: 'Invoice', objectId: this.props.invoiceId};
                
            this.props.dispatch({type: 'app/showButtonLoading'})

            create('InvoiceMessage', data).then(resp => {
                this.props.dispatch({type: 'app/hideButtonLoading'})
                this.props.form.resetFields();

                resp.user = this.props.app.user;
                _.extend(data, resp);
                this.setState({messages: [data, ...this.state.messages]});

            }).catch(e => {
                this.props.dispatch({type: 'app/hideButtonLoading'})

                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


  	/**
    * Render del componente
    */
    render () {
	    return (
            <div>
                <Form>
                    <div className="row">
                        <div className="col-md-12">
                            <FormItem label="Escribe un nuevo mensaje" hasFeedback>
                                {this.props.form.getFieldDecorator('message', {
                                    rules: [{
                                        required: true,
                                        message: 'El mensaje no debería estar en blanco'
                                    }]
                                })(<TextArea rows={3} />)}
                            </FormItem>

                            <Button type='primary' onClick={this.createMessage.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Form>

                <Card title="Lista de Mensajes" className="marginTop20 messages">
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="row">
                            <div className="col-md-12">
                                {this.state.messages.length > 0
                                    ? <Timeline pending={this.state.skip < this.state.total_items ? <a onClick={this.loadMore.bind(this)} href="">Ver más</a> : ''}>
                                        {
                                            this.state.messages.map(item => 
                                                <Timeline.Item key={item.objectId}>
                                                    {item.message}<br />
                                                    <small><i>{item.user.name}</i></small><br />
                                                    <small>{moment(item.createdAt).format('lll')}</small>
                                                </Timeline.Item>
                                            )
                                        }
                                    </Timeline>
                                    : 'No hay mensajes'
                                }
                            </div>
                        </div>
                    </Spin>
                </Card>
            </div>
	    )
	}
}

export default connect(({currentInvoice, app}) => ({currentInvoice, app}))(Form.create()(InvoiceMessage))


// WEBPACK FOOTER //
// ./src/components/invoices/invoiceMessage.js